<template>
  <div class="mobile_organization">
    <div class="title-bar flex-center-center">包赔资料提交</div>
    <div class="tip-bar flex-center-center">以下信息将录入合同，虚假提供触发违约，后果自负！</div>
    <div class="container">
      <div class="title-label">
        <div class="line"></div>
        账号信息
      </div>
      <div class="card" v-if="dynamicConfig.accountConfig && dynamicConfig.accountConfig.length">
        <div :class="['inputItem', item.prop == 'gameId' && 'arrow', (item.prop == 'riddleImg' || item.prop == 'extra3' || item.prop == 'alipayImg') && 'backImg']" v-for="item in dynamicConfig.accountConfig" :key="item.key">
          <div :class="['require-mark', !(item.prop == 'riddleImg' || item.prop == 'extra3' || item.prop == 'alipayImg') && 'require-mark-center']" v-if="item.required === true">*</div>
          <template v-if="item.prop == 'gameId'">
            <div class="label_format"><label class="label_format_child">{{ item.label }}：</label></div>
            <input v-model="gameName" type="text" @focus="noBomBox" :placeholder="`请选择${ item.label }`" @click="showPopupFunc('gameList')">
          </template>
          <template v-else-if="item.prop == 'riddleImg'">
            <div class="rightClass flex-center-sb">
              <label class="label_format_child">防沉迷截图：</label>
              <span @click="previewImgData(1)">*查看示例</span>
            </div>
            <van-uploader v-model="fileList1" :max-count="1" :after-read="(file)=>{return afterRead(file, type = 'riddleImg')}" :before-delete="(file)=>{return beforeDelete(file, type = 'riddleImg')}" @oversize="onOversize" :preview-options="{closeable:'true'}" image-fit="cover">
              <div class="classData">
                <van-icon name="plus" size="16" />
                <span>上传</span>
              </div>
            </van-uploader>
          </template>

          <template v-else-if="item.prop == 'extra3'">
            <div class="rightClass flex-center-sb">
              <label class="label_format_child">近期网购订单：</label>
              <span @click="previewImgData(2)">*查看示例</span>
            </div>
            <van-uploader v-model="fileList2" :max-count="1" :after-read="(file)=>{return afterRead(file, type = 'extra3')}" :before-delete="(file)=>{return beforeDelete(file, type = 'extra3')}" @oversize="onOversize" :preview-options="{closeable:'true'}">
              <div class="classData">
                <van-icon name="plus" />
                <span>上传</span>
              </div>
            </van-uploader>
          </template>
          <template v-else-if="item.prop == 'alipayImg'">
            <div class="rightClass flex-center-sb">
              <label class="label_format_child">{{ item.label }}</label>
              <span @click="previewImgData('alipayImg')">*查看示例</span>
            </div>
            <van-uploader v-model="alipayImgList" :max-count="1" :after-read="(file)=>{return afterRead(file, type = 'alipayImg')}" :before-delete="(file)=>{return beforeDelete(file, type = 'alipayImg')}" @oversize="onOversize" :preview-options="{closeable:'true'}" image-fit="cover">
              <div class="classData">
                <van-icon name="plus" size="16" />
                <span>上传</span>
              </div>
            </van-uploader>
          </template>
          <!-- 账号来源 -->
          <template v-else-if="item.prop == 'accountSource'">
            <div class="label_format"><label class="label_format_child">{{ item.label }}：</label></div>
            <el-select v-model="personalForm[item.prop]" class="collection-select" :placeholder="`选择${item.label}`" clearable>
              <el-option v-for="dict in accountSourceList" :key="dict.value" :label="dict.label" :value="dict.value" />
            </el-select>
          </template>
          <template v-else>
            <div class="label_format"><label class="label_format_child">{{ item.label }}：</label></div>
            <input type="text" v-model="personalForm[item.prop]" :placeholder="`请输入${ item.label }`">
          </template>
        </div>
      </div>

      <div class="title-label">
        <div class="line"></div>
        号主信息
      </div>
      <div class="card" v-if="dynamicConfig.personConfig && dynamicConfig.personConfig.length">
        <div :class="['inputItem', (item.prop == 'cardFront' || item.prop == 'cardBack') && 'backImg']" v-for="item in dynamicConfig.personConfig" :key="item.key">
          <div :class="['require-mark', !(item.prop == 'cardFront' || item.prop == 'cardBack') && 'require-mark-center']" v-if="item.required === true">*</div>
          <template v-if="item.prop == 'cardFront'">
            <div class="rightClass flex-center-sb" style="margin-bottom: 10px;">
              <label class="label_format_child">上传身份证（正面）</label>
            </div>
            <div class="idcard flex-center-sb">
              <div class="idcard_uploader">
                <van-uploader v-model="fileList3" :max-count="1" :after-read="(file)=>{return afterRead(file, type = 'cardFront')}" :before-delete="(file)=>{return beforeDelete(file, type = 'cardFront')}" @oversize="onOversize" :preview-options="{closeable:'true'}">
                  <div class="classData_idcard">
                    <img src="@/assets/images/id1.png" />
                  </div>
                </van-uploader>
                <span class="tit">身份证人像面</span>
              </div>
            </div>
          </template>
          <template v-else-if="item.prop == 'cardBack'">
            <div class="rightClass flex-center-sb" style="margin-bottom: 10px;">
              <label class="label_format_child">上传身份证（反面）</label>
            </div>
            <div class="idcard flex-center-sb">
              <div class="idcard_uploader">
                <van-uploader v-model="fileList4" :max-count="1" :after-read="(file)=>{return afterRead(file, type = 'cardBack')}" :before-delete="(file)=>{return beforeDelete(file, type = 'cardBack')}" @oversize="onOversize" :preview-options="{closeable:'true'}">
                  <div class="classData_idcard">
                    <img src="@/assets/images/id2.png" />
                  </div>
                </van-uploader>
                <span class="tit">身份证国徽面</span>
              </div>
            </div>
          </template>
          <!-- 收款方式 -->
          <template v-else-if="item.prop == 'collection'">
            <div class="label_format"><label class="label_format_child">{{ item.label }}：</label></div>
            <el-select v-model="personalForm[item.prop]" class="collection-select" :placeholder="`选择${item.label}`" clearable>
              <el-option v-for="dict in collectionOptions" :key="dict.value" :label="dict.label" :value="dict.value" />
            </el-select>
          </template>
          <template v-else>
            <div class="label_format"><label class="label_format_child">{{ item.label }}：</label></div>
            <input type="text" v-model="personalForm[item.prop]" :placeholder="`请输入${ item.label }`">
          </template>
        </div>
      </div>
      <div class="card" v-if="dynamicConfig.friendConfig && dynamicConfig.friendConfig.length">
        <div class="inputItem inputItem-col">
          <div :class="['require-mark']" v-if="dynamicConfig.friendConfig[0].required">*</div>
          <div class="label_format"><label class="label_format_child">亲友1类型：</label></div>
          <input v-model="relationShipName" type="text" @focus="noBomBox" placeholder="请选择亲友类型" @click="showPopupFunc('relationShipList','1')">
        </div>
        <div class="inputItem inputItem-col">
          <div :class="['require-mark']" v-if="dynamicConfig.friendConfig[0].required">*</div>
          <div class="label_format"><label class="label_format_child">亲友1姓名：</label></div>
          <input v-model="personalForm.extra1" type="text" placeholder="请输入亲友姓名">
        </div>
        <div class="inputItem inputItem-col">
          <div :class="['require-mark']" v-if="dynamicConfig.friendConfig[0].required">*</div>
          <div class="label_format"><label class="label_format_child">亲友1手机：</label></div>
          <input v-model="personalForm.extra2" type="text" placeholder="请输入亲友手机号">
        </div>
        <div class="inputItem">
          <input v-model="personalForm.code" type="text" placeholder="请输入请输入验证码">
          <button v-show="countdown1 == 0" class="sendCode" @click="startCountdown(personalForm.extra2,'countdown1')">发送验证码</button>
          <button v-show="countdown1 > 0" class="sendCode">重新发送{{ countdown1 + '秒' }}</button>
        </div>
        <!-- 字段不同 亲友2-->
        <div class="inputItem inputItem-col">
          <div :class="['require-mark']" v-if="dynamicConfig.friendConfig[1].required">*</div>
          <div class="label_format"><label class="label_format_child">亲友2类型：</label></div>
          <input v-model="relationShipName2" type="text" @focus="noBomBox" placeholder="请选择亲友类型" @click="showPopupFunc('relationShipList','2')">
        </div>
        <div class="inputItem inputItem-col">
          <div :class="['require-mark']" v-if="dynamicConfig.friendConfig[1].required">*</div>
          <div class="label_format"><label class="label_format_child">亲友2姓名：</label></div>
          <input v-model="personalForm.contactName" type="text" placeholder="请输入亲友姓名">
        </div>
        <div class="inputItem inputItem-col">
          <div :class="['require-mark']" v-if="dynamicConfig.friendConfig[1].required">*</div>
          <div class="label_format"><label class="label_format_child">亲友2手机：</label></div>
          <input v-model="personalForm.contactPhone" type="text" placeholder="请输入亲友手机号">
        </div>
        <div class="inputItem">
          <input v-model="personalForm.code" type="text" placeholder="请输入请输入验证码">
          <button v-show="countdown2 == 0" class="sendCode" @click="startCountdown(personalForm.contactPhone,'countdown2')">发送验证码</button>
          <button v-show="countdown2 > 0" class="sendCode">重新发送{{ countdown2 + '秒' }}</button>
        </div>
      </div>
      <div class="submit">
        <span>亲友姓名号码会联合公网自动校验，不匹配直接取消交易</span>
        <button class="nextBtn" @click="submitForm">提交</button>
      </div>
      <div class="footer-tip">
        承诺声明：所提交的信息，仅用于电子合同信息录入及交易纠纷引起的起诉所需材料备份，我们承诺绝对保密，绝不外泄！
      </div>
    </div>

    <van-popup v-model="popupObject.show" round position="bottom" :style="{ height: '40%' }">
      <van-picker :title="popupObject.title" show-toolbar :columns="popupObject.columns" @confirm="onPopupConfirm" @cancel="onPopupCancel" />
    </van-popup>
  </div>
</template>
<script>
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import { Icon, Area, Popup, DatetimePicker, Uploader, Toast, Picker, ImagePreview } from 'vant'
import { uploadFileToOSS } from '@/util/ossUpload'

export default {
  mixins: [listSearchMixin],
  name: 'mPersonalBusiness',
  components: {
    [Icon.name]: Icon,
    [Area.name]: Area,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Picker.name]: Picker
  },
  computed: {
    isOss() {
        return 1 || this.$route.query.isOss // 获取路由参数
    }
  },
  data() {
    return {
      deptId: '',
      // 动态配置
      dynamicConfig: {
        accountConfig: [],
        personConfig: []
      },
      countdown1: 0, // 倒计时
      countdown2: 0, // 倒计时

      popupObject: {
        title: '',
        type: '',
        show: false,
        columns: []
      },
      relationShipShow: false,

      gameName: null, // 游戏名称
      gameList: [], // 游戏列表
      relationShipName: null,
      relationShipName2: null,
      relationShipList: [], // 关系列表

      regionShow: false,
      idTypeShow: false,

      fileList1: [], // 防沉迷
      fileList2: [], // 近期网购
      fileList3: [], // 身份证-正
      fileList4: [], // 身份证-反
      alipayImgList: [], // 支付宝截图

      collectionOptions: [ // 收款方式 固定
        { label: '支付宝转账', value: '支付宝' },
        { label: '微信转账', value: '微信' },
        { label: '银行卡转账', value: '银行卡' }
      ],
      // '自己注册', '其他平台购买', '他人赠送'
      accountSourceList: [{label:'自己注册',value:'0'},{label:'其他平台购买',value:'1'},],
      personalForm: {
        mapAddress: '', // 地址
        longitude: '', // 经度
        latitude: '', // 纬度

        gameId: '', // 游戏名称
        gameAccount: '', // 游戏账号
        pwd: '', // 登录密码
        transAmt: '', // 交易金额
        bindPhone: '', // 绑定手机
        device: '', // 登录设备
        amount: '', // 历史充值
        accountSource: '', // 账号来源
        played: '', // 近期游戏
        login: '', // 常玩地址
        riddleImg: '', // 防沉迷截图
        extra3: '', // 近期网购订单截图
        alipayImg:'', // 支付宝截图
        name: '', // 号主姓名
        card: '', // 身份证号
        salerAddress: '', // 身份证地址
        linkPhone: '', // 联系电话
        lwechat: '', // 联系微信
        email: '', // 邮箱账号
        address: '', // 常住地址
        collection: '', // 收款方式
        accountNo: '', // 收款账号
        cardFront: '', // 身份证正面截图
        cardBack: '', // 身份证背面截图

        relationShip: '', // 亲友类型
        extra1: '', // 亲友名称
        extra2: '', // 亲友手机
        relationShipTwo: '', //亲友类型2
        contactName: '', // 亲友2名称
        contactPhone: '', // 亲友2手机
        key: '', // 验证码key
        code: '' // 验证码值
      }
    }
  },
  created() {
    // 获取 hash 部分（包括 ?）
    const hash = window.location.href.replace('#/', '') // 结果: "#/?deptId=245"
    console.log('hash: ', hash)
    let deptId = null
    if (hash.includes('?')) {
      deptId = hash.split('?')[1].split('=')[1]
    }
    this.deptId = deptId
    if (this.deptId) {
      this.getDynamicConfig(this.deptId)
    } else {
      Toast('当前网址无法确定部门参数，请检查网址是否正确！')
      throw new Error('当前网址无法确定部门参数，请检查网址是否正确！')
    }
  },
  mounted() {
    // this.loadBMap().then(() => {
    //   this.getAddressIp()
    // })
    this.getAddressIp1()
    this.getRelDictList()
    this.getDictGameList()
  },
  methods: {
    // 获取动态配置
    getDynamicConfig(deptId) {
      this.dynamicConfig = {
        accountConfig: [],
        personConfig: [],
        friendConfig: []
      }
      let self = this
      let params = {
        url: api.getBaoPeiConfig + '/' + deptId,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === 200 && res.data && res.data.length) {
          res.data.forEach(item => {
            if (item.visible === true) {
              if (item.infoType === 'accountInfo') this.dynamicConfig.accountConfig.push(item)
              if (item.infoType === 'personInfo') this.dynamicConfig.personConfig.push(item)
              if (item.infoType === 'friendInfo') this.dynamicConfig.friendConfig.push(item)
              if (item.prop === 'collection' && item.value) {
                let valueList = item.value
                if (typeof item.value === 'string') {
                  valueList = [item.value]
                }
                if (valueList && valueList.length === 1) {
                  this.personalForm.collection = item.value
                }
                this.collectionOptions = valueList.map(item => {
                  return { label: `${item}转账`, value: item }
                })
              }
            } else {
              if (item.prop === 'mapAddress') { // 定位获取
                this.mapAddressItem = item
                console.log('this.mapAddressItem: ', this.mapAddressItem);
              }
            }
          })
        } else {
          Toast(res.msg)
        }
      })
    },
    // 弹窗公用方式
    showPopupFunc(type,num) {
      this.popupObject.type = type
      this.relationShipNum = num
      if (type === 'gameList') {
        this.popupObject.title = '请选择游戏名称'
        this.popupObject.columns = this.gameList
      } else if (type === 'relationShipList') {
        this.popupObject.title = '请选择亲友类型'
        this.popupObject.columns = this.relationShipList
      }
      this.popupObject.show = true
    },
    // 弹窗确认
    onPopupConfirm(dict) {
      if (this.popupObject.type === 'gameList') {
        this.gameName = dict.text
        this.personalForm.gameId = dict.value
        this.popupObject.show = false
      } else if (this.popupObject.type === 'relationShipList') {
        this[this.relationShipNum == '1' ? 'relationShipName' : 'relationShipName2'] = dict.text
        this.personalForm[this.relationShipNum == '1' ?'relationShip' :'relationShipTwo'] = dict.value
        this.popupObject.show = false
      }
    },
    // 弹窗取消
    onPopupCancel() {
      if (this.popupObject.type === 'gameList') {
        this.popupObject.show = false
      } else if (this.popupObject.type === 'relationShipList') {
        this[this.relationShipNum == '1' ? 'relationShipName' : 'relationShipName2'] = ''
        this.personalForm[this.relationShipNum == '1' ?'relationShip' :'relationShipTwo'] = ''
        this.popupObject.show = false
      }
    },

    // 禁止弹出键盘
    noBomBox(Event) {
      document.activeElement.blur()
    },
    previewImgData(img) {
      var obj = []
      if (img === 1) {
        obj.push('https://file.hswlkj.com/20260131/176984862728717698486274074279727618868.png')
      }
      if (img === 2) {
        obj.push('https://file.hswlkj.com/20260130/176975778622017697577864360678569277172.jpeg')
      }
      if (img === 'alipayImg') {
        obj.push('https://file.hswlkj.com/20260131/176983878181517698387818647951881361878.png')
      }
      ImagePreview({
        images: obj,
        closeable: true
      })
    },
    beforeDelete(file, type) {
      if (type === 'riddleImg') {
        this.personalForm.riddleImg = ''
        this.fileList1 = [] // 防沉迷
      } else if (type === 'extra3') {
        this.personalForm.extra3 = ''
        this.fileList2 = [] // 近期网购
      } else if (type === 'cardFront') {
        this.personalForm.cardFront = ''
        this.fileList3 = [] // 身份证-正
      } else if (type === 'cardBack') {
        this.personalForm.cardBack = ''
        this.fileList4 = [] // 身份证-反
      } else if (type === 'alipayImg') {
        this.personalForm.alipayImg = ''
        this.alipayImgList = [] // 身份证-反
      }
    },
    afterRead(file, type) {
      this.fileListCopy = Array.isArray(file) ? file : [file]
      this.fileListCopy.forEach((item) => {
        item.status = 'uploading'
        item.message = '上传中...'

        let self = this
        console.log('this.isOss: ', this.isOss)
        if (this.isOss == 1) { // // 阿里云 上传
          let isLt2M = item.file.size / 1024 / 1024 // 判定图片大小
          const compress = isLt2M <= 0.2 ? 1
                        : isLt2M <= 2 ? 0.7
                        : isLt2M <= 4 ? 0.5
                        : isLt2M <= 6 ? 0.4
                        : 0.3
          let image = new Image()
          let resultBlob = ''
          image.src = URL.createObjectURL(item.file)
          image.onload = async () => {
            resultBlob = compress == 1 ? item.file : self.compressUpload(image, item.file, compress)
            self.aliyunHandle(item.file, resultBlob, item, type) // 阿里云 上传
          }
          return
        }
        let formData = new FormData()
        formData.append('file', this.dataURLtoFileFun(item.content, item.file.name))
        let params = {
          url: api.upload,
          method: 'POST',
          contentType: 'multipart/form-data',
          data: formData
        }
        self.sendReq(params, (res) => {
          if (res.code == 200) {
            if (type === 'riddleImg') {
              self.personalForm.riddleImg = res.url
            } else if (type === 'extra3') {
              self.personalForm.extra3 = res.url
            } else if (type === 'cardFront') {
              self.personalForm.cardFront = res.url
            } else if (type === 'cardBack') {
              self.personalForm.cardBack = res.url
            }else if (type === 'alipayImg') {
              self.personalForm.alipayImg = res.url
            }
            item.status = 'done '
          } else {
            item.status = 'failed'
            Toast(res.msg)
          }
        }, () => {
          item.status = 'failed'
          item.message = '请求超时'
        })
      })
    },
    // 阿里云 上传图片
    async aliyunHandle (file, resultBlob, item, type) {
      console.log('file, resultBlob, item, type: ', file, resultBlob, item, type)
      const res = await uploadFileToOSS(file, resultBlob)
      console.log('resresresres', res)
      if (res.status === 200) {
        if (type === 'riddleImg') {
          this.personalForm.riddleImg = res.url
        } else if (type === 'extra3') {
          this.personalForm.extra3 = res.url
        } else if (type === 'cardFront') {
          this.personalForm.cardFront = res.url
        } else if (type === 'cardBack') {
          this.personalForm.cardBack = res.url
        }else if (type === 'alipayImg') {
          this.personalForm.alipayImg = res.url
        }

        item.status = 'done '
      } else {
        item.status = 'failed'
        Toast('上传失败')
      }
    },
    orderHandle (arr1, arr2) {
      this.$nextTick(() => {
        this.imgList = this.imgList.concat(arr2.map(item => arr1.find(item1 => item.file.name == item1.fileName).url))
        this.imgOrderList = []
      })
    },
    /* 图片压缩方法-canvas压缩  根据画质压缩图片 */
    compressUpload(image, file, quality) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let { width, height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)
      const type = file.type ? (file.type == 'image/png' ? 'image/jpeg' : file.type) : 'image/jpeg'
      let base64 = canvas.toDataURL(type, quality)
      // 压缩后调用方法进行base64转Blob
      const boldFile = this.base64ToBlob(base64, type)
      return boldFile
      canvas = null
    },
    // base64转Blob
    base64ToBlob (base64, contentType = '') {
      // 去除Base64字符串的前缀
      const cleanedBase64 = base64.split(',')[1] || base64
      // 对Base64字符串进行解码
      const byteCharacters = atob(cleanedBase64)
      // 将解码后的二进制字符串转换为Uint8Array
      const byteArrays = []
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i))
      }
      const byteArray = new Uint8Array(byteArrays)

      // 创建Blob对象
      return new Blob([byteArray], { type: contentType })
    },

    dataURLtoFileFun(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {
        type: mime
      })
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 500kb')
    },
    // 提交申请
    submitForm() {
      let self = this
      if (!this.deptId) {
        Toast('当前网址无法确定部门参数，请检查网址是否正确！')
        return false
      }
      if (this.mapAddressItem && this.mapAddressItem.required === true && self.personalForm.mapAddress === '') {
        Toast('未获取到位置信息，正在尝试重新获取中...')
        this.loadBMap().then(() => {
          this.getAddressIp()
        })
        return false
      }

      let verificationConfig = [...this.dynamicConfig.accountConfig, ...this.dynamicConfig.personConfig].filter(item => item.required === true)
      let validMsg = ''
      const isValid = verificationConfig.some(item => {
        if (self.personalForm[item.prop] === '' || self.personalForm[item.prop] === null) {
          validMsg = item.label
          return true
        }
      })

      if (isValid) {
        Toast(`请输入${validMsg}`)
        return false
      }
      if (this.dynamicConfig.friendConfig.length && this.dynamicConfig.friendConfig[0].required) {
          // 必填
        if (self.personalForm.relationShip === '') {
          Toast('请选择亲友类型')
          return false
        }
        if (self.personalForm.extra1 === '') {
          Toast('请输入亲友名称')
          return false
        }
        if (self.personalForm.extra1.length < 2) {
          Toast('名字不合法')
          return false
        }
        if (self.personalForm.extra2 === '') {
          Toast('请输入亲友手机号')
          return false
        }
        if (self.personalForm.code === '') {
          Toast('请输入验证码值')
          return false
        }
      }

      let ifNameRequired = verificationConfig.find(item => item.prop === 'name')
      if (ifNameRequired && ifNameRequired.required === true && self.personalForm.name.length < 2) {
        Toast('号主姓名不合法')
        return false
      }
      let ifBindPhoneRequired = verificationConfig.find(item => item.prop === 'bindPhone')
      if (ifBindPhoneRequired && ifBindPhoneRequired.required === true && self.personalForm.bindPhone.length !== 11) {
        Toast('绑定手机号位数不对')
        return false
      }
      let ifCardRequired = verificationConfig.find(item => item.prop === 'card')
      if (ifCardRequired && ifCardRequired.required === true && self.personalForm.card.length !== 18) {
        Toast('身份证位数不对')
        return false
      }
      let ifLinkPhoneRequired = verificationConfig.find(item => item.prop === 'linkPhone')
      if (ifLinkPhoneRequired && ifLinkPhoneRequired.required === true && self.personalForm.linkPhone.length !== 11) {
        Toast('联系电话位数不对')
        return false
      }
      let params = {
        url: api.organizationsCheck,
        method: 'POST',
        data: self.personalForm
      }
      self.sendReq(params, (res) => {
        if (res.code === 200) {
          Toast.success('提交成功')
          self.resetData()
          self.countdown1 = 0
          self.countdown2 = 0
          // self.$router.push({path: '/mStatus'})
        } else {
          Toast(res.msg)
        }
      })
    },
    resetData() {
      this.personalForm = {
        mapAddress: '', // 地址
        longitude: '', // 经度
        latitude: '', // 纬度

        gameId: '', // 游戏名称
        gameAccount: '', // 游戏账号
        pwd: '', // 登录密码
        transAmt: '', // 交易金额
        bindPhone: '', // 绑定手机
        device: '', // 登录设备
        amount: '', // 历史充值
        played: '', // 近期游戏
        login: '', // 常玩地址
        riddleImg: '', // 防沉迷截图
        extra3: '', // 近期网购订单截图
        alipayImg:'',
        name: '', // 号主姓名
        card: '', // 身份证号
        salerAddress: '', // 身份证地址
        linkPhone: '', // 联系电话
        lwechat: '', // 联系微信
        email: '', // 邮箱账号
        address: '', // 常住地址
        collection: '', // 收款方式
        accountNo: '', // 收款账号
        cardFront: '', // 身份证正面截图
        cardBack: '', // 身份证背面截图

        relationShip: '', // 亲友类型
        extra1: '', // 亲友名称
        extra2: '', // 亲友手机
        key: '', // 验证码key
        code: '' // 验证码值
      }
      this.fileList1 = [] // 防沉迷
      this.fileList2 = [] // 近期网购
      this.alipayImgList = [] // 支付宝截图
      this.fileList3 = [] // 身份证-正
      this.fileList4 = [] // 身份证-反
    },
    // 开启倒计时
    startCountdown(phoneNumber,downType) {
      let params = {
        url: api.sendCode,
        method: 'POST',
        data: {extra2: phoneNumber}
      }
      this.sendReq(params, (res) => {
        if (res.code === 200) {
          this.personalForm.key = res.data.uuid
          this[downType] = 59
          this.timer = setInterval(() => {
            if (this[downType] > 0) {
              this[downType]--
            } else {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          Toast(res.msg)
        }
      })
    },
    getDictGameList() {
      let self = this
      let params = {
        url: api.getDictData + '/sys_game_type',
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === 200) {
          self.gameList = res.data
          self.gameList.forEach((item) => {
            item.text = item.dictLabel
            item.value = item.dictValue
          })
        }
      })
    },
    getRelDictList() {
      let self = this
      let params = {
        url: api.getDictData + '/sys_relation_ship',
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === 200) {
          self.relationShipList = res.data
          self.relationShipList.forEach((item) => {
            item.text = item.dictLabel
            item.value = item.dictValue
          })
        }
      })
    },
    loadBMap() {
      return new Promise((resolve, reject) => {
        if (window.BMap) {
          resolve()
          return
        }
  
        const script = document.createElement("script");
        script.src = `https://api.map.baidu.com/api?v=2.0&ak=你的AK&callback=onBMapLoadJS`;
        script.onerror = reject
        window.onBMapLoadJS = () => {
          resolve()
        };
        document.head.appendChild(script)
      })
    },
    // 获取地理位置
    // getAddressIp() {
    //   const geolocation = new BMap.Geolocation()
    //   let _this = this
    //   geolocation.getCurrentPosition(function getinfo(position) {
    //       _this.personalForm.longitude = position.point.lng
    //       _this.personalForm.latitude = position.point.lat

    //       let point = new BMap.Point(position.point.lng, position.point.lat)
    //       let gc = new BMap.Geocoder()
    //       gc.getLocation(point, function (res) {
    //         console.log('位置', res)
    //         if (res) {
    //           _this.personalForm.mapAddress = res.address
    //         } else {
    //           _this.personalForm.mapAddress = position.address.province + position.address.city + position.address.district + position.address.street
    //         }
    //       })
    //     }, function (e) {}, {
    //       provider: 'baidu'
    //     }
    //   )
    // },
    getAddressIp1(){
      if ("geolocation" in navigator) {
				if (navigator.geolocation) {
					this.loadBMap().then(() => {
						this.getAddressIp();
				  });
					// 请求当前位置
					navigator.geolocation.getCurrentPosition(this.successFun, (error) => {
			    // 处理错误
			    switch(error.code) {
			    	case error.PERMISSION_DENIED:
			    		console.log("User denied the request for Geolocation.");
			    break;
			  	case error.POSITION_UNAVAILABLE:
			  		console.log("Location information is unavailable.");
			  		break;
			  	case error.TIMEOUT:
			  		console.log("The request to get user location timed out.");
			  		break;
			  	case error.UNKNOWN_ERROR:
						console.log("An unknown error occurred.");
						break;
						}
					});
				} else {
          alert('获取位置失败')
				}
			}
    },
    async successFun(position) {
      console.log('position: ', position);
      try {
        const lat = position.latitude ||  position.coords.latitude ;
        const lng = position.longitude || position.coords.longitude;
        const geoCoder = new T.Geocoder()
        const point = new T.LngLat(lng, lat);
        geoCoder.getLocation(point,(res) => {
          if( res.addressComponent) {
            const {address,province,city,county,town} = res.addressComponent
            this.personalForm.mapAddress = `${province}${city}${county}${town}${address}(${lng},${lat})`
            console.log(' this.personalForm.mapAddress : ',  this.personalForm.mapAddress );
          }else {
            const { city,district,province} = position.contactAddress
            this.personalForm.mapAddress = `${province}${city}${district}(${lng},${lat})`
          }
        })
      } catch (error) {
        const { city,district,province} = position.contactAddress
        this.personalForm.mapAddress = `${province}${city}${district}`
      }
    },
    getAddressIp() {
      const geolocation = new BMap.Geolocation();
			geolocation.getCurrentPosition(this.successFun, { provider: 'baidu' });
    },
  }
}
</script>
<style lang="scss" scoped>
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile_organization {
  margin: auto;
  padding-bottom: 40px;
  width: 100%;
  max-width: 450px;
  height: 100vh;
  overflow-y: auto;
  background: #f3f7fa;
  font-family: PingFangSC, PingFang SC;

  .title-bar {
    height: 44px;
    font-weight: 600;
    font-size: 16px;
    color: #111111;
  }

  .tip-bar {
    height: 30px;
    background: #feece5;
    font-weight: 600;
    font-size: 12px;
    color: #fe4400;
  }

  .container {
    padding: 0 10px;
    box-sizing: border-box;

    .title-label {
      margin-top: 20px;
      font-weight: 600;
      font-size: 14px;
      color: #111111;
      display: flex;
      align-items: center;

      .line {
        margin-left: 10px;
        margin-right: 8px;
        width: 4px;
        height: 20px;
        background: linear-gradient(90deg, #fe2f39 0%, #ff6634 100%);
        border-radius: 6px;
      }
    }

    .card {
      margin-top: 10px;
      padding: 15px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;

      .inputItem {
        position: relative;
        display: flex;
        align-items: center;

        .require-mark{
          position: absolute;
          color: red;
          top: 0;
          left: -10px;

          &.require-mark-center{
            top: 50%;
            transform: translateY(-50%);
          }
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        .label_format {
          font-weight: 600;
          font-size: 14px;
          color: #111111;
          flex-shrink: 0;
        }

        .label_format_child {
          font-weight: 600;
          font-size: 14px;
          color: #111111;
          flex-shrink: 0;
        }

        input {
          padding-left: 10px;
          width: 100%;
          height: 44px;
          font-size: 14px;
          color: #111111;
          border: 1px solid rgba(0, 0, 0, 0.2);
          border-radius: 8px;
        }

        input::placeholder {
          position: relative;
          top: -1px;
          font-size: 14px;
          color: #aaaaaa;
        }

        .sendCode {
          position: absolute;
          right: 0;
          width: 120px;
          height: 44px;
          font-size: 14px;
          color: #ffd8a1;
          background: #333333;
          border-radius: 0px 8px 8px 0px;
        }
        .collection-select.el-select {
          width: 100%;
        }
      }

      .inputItem-col {
        flex-direction: column;
        align-items: flex-start;

        .label_format {
          margin-bottom: 5px;
        }
      }

      .backImg {
        flex-direction: column;
        align-items: flex-start;

        .rightClass {
          margin-bottom: 5px;
          width: 100%;

          > span {
            font-size: 12px;
            color: #fe4400;
          }
        }

        .classData {
          width: 70px;
          height: 70px;
          font-size: 10px;
          color: #aaaaaa;
          border-radius: 8px;
          border: 1px solid rgba(0, 0, 0, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          > span {
            margin-top: 2px;
          }
        }

        .idcard {
          width: 100%;

          .idcard_uploader {
            width: calc(50% - 10px);
            display: flex;
            flex-direction: column;
            align-items: center;

            .tit {
              margin-top: 5px;
              font-size: 12px;
              color: #aaaaaa;
            }

            .classData_idcard {
              padding: 5px;
              box-sizing: border-box;
              border: 1px solid rgba(0, 0, 0, 0.2);
              border-radius: 8px;
              overflow: hidden;

              > img {
                width: 100%;
                height: 90px;
              }
            }
          }
        }
      }
    }

    .submit {
      position: relative;
      margin-top: 20px;
      padding-top: 4px;
      box-sizing: border-box;
      height: 78px;
      background: #feece5;
      border-radius: 8px;
      text-align: center;

      > span {
        font-size: 12px;
        color: #fe4400;
      }

      .nextBtn {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 48px;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        background: linear-gradient(90deg, #fa5e00 0%, #ff8800 100%);
        border-radius: 8px;
      }
    }

    .footer-tip {
      margin-top: 20px;
      font-size: 12px;
      line-height: 16px;
      color: #aaaaaa;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/moblie/mOtherOrg.vue